import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tooltip from './Tooltip';
import './CustomPie.scss';

class CustomPie extends Component {
  state = {
    percent: 0, 
    isMouseIn: false  
  }

  componentDidMount() {
    const { percent } = this.props;
    this.setState({
      percent
    })
  }
  
  componentDidUpdate() {
    const { percent } = this.props;
    if (this.state.percent !== percent) {
      this.setState({// eslint-disable-line
        percent
      });
    }
  }

  toggleTooltip = value => {
    this.setState({
      isMouseIn: value
    });
  };

  render() {
    const { pieSize, strokeWidth, gradient, hasTooltip } = this.props;
    const { percent, isMouseIn } = this.state;
    const viewBox = `0 0 ${pieSize} ${pieSize}`;
    const radius = (pieSize - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = (100 - percent) / 100 * circumference;
    
    return (
      <div className="custom-pie">
        <svg width={pieSize} height={pieSize} viewBox={viewBox} style={{ maxHeight: '100%', maxWidth: '100%' }} >
          <circle
            className="custom-pie__circle-background"
            cx={pieSize/2}
            cy={pieSize/2}
            r={radius}
            strokeWidth={`${strokeWidth}px`}
          />
          <circle
            className="custom-pie__circle-progress"
            cx={pieSize / 2}
            cy={pieSize / 2}
            r={radius}
            strokeWidth={`${strokeWidth}px`}
            transform={`rotate(-90 ${pieSize / 2} ${pieSize / 2})`}
            style={{
              strokeDasharray: circumference,
              strokeDashoffset: offset,
              stroke: gradient
            }}
            onMouseEnter={()=> this.toggleTooltip(true)}
            onMouseLeave={()=> this.toggleTooltip(false)}
          />
        </svg>
        {hasTooltip && <Tooltip percent={percent} isVisible={isMouseIn}/>}
      </div>
    );
  }
};

CustomPie.propTypes = {
  gradient: PropTypes.string,
  hasTooltip: PropTypes.bool,
  percent: PropTypes.number,
  pieSize: PropTypes.number,
  strokeWidth: PropTypes.number
};

CustomPie.defaultProps = {
  gradient: '',
  hasTooltip: false,
  percent: 0, 
  pieSize: 100, 
  strokeWidth: 10
};

export default CustomPie;
